export default "__VITE_ASSET__05084c46__"